/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import Footer from '../../Components/Footer';
import Header from '../../Components/Header';
import InfoCompanyStatus from '../../Containers/InfoCompanyStatus';
import Appliants from '../../Containers/Appliants';
import Platforms from '../../Containers/Platforms';
import axios from 'axios';
import $ from 'jquery';
import { useSelector } from 'react-redux';
import ModalLogin from '../../Containers/Modal_Login';
import ModalRegister from '../../Containers/Modal_Register';
import ModalAction from '../../Containers/ModalAction';
import ModalResetPassword from '../../Containers/FormResetPassword';
import ModalResult from '../../Containers/ModalResult';

const Dashboard = () => {
  const { user } = useSelector((state) => state.app);
  const [profile, setProfile] = useState();
  const [applications, setApplications] = useState();
  const [application, setApplication] = useState();

  useEffect(() => {
    axios.get(`/api/v1/dashboard/platform`).then(({ data }) => {
      if (data.success) {
        setProfile(data.payload.profile);
        setApplications(data.payload.appliants);
      }
    });
  }, [application]);

  const openAction = (app) => {
    setApplication(app);
    $('#modal-action').addClass('show').css('display', 'block');
    $('body')
      .addClass('modal-open')
      .append("<div class='modal-backdrop fade show'></div>");
  };

  const openFormResetPassword = () => {
    $('#modal-form-reset-password').addClass('show').css('display', 'block');
    $('body')
      .addClass('modal-open')
      .append("<div class='modal-backdrop fade show'></div>");
  };

  return (
    <div className='profile-page'>
      <Header />
      <main>
        <div className='profile pr'>
          <div className='container'>
            <div className='row'>
              {user?.active == 1 ? (
                <div className='col-lg-12 col-md-12'>
                  <Platforms
                    user={user}
                    openFormResetPassword={openFormResetPassword}
                  />
                </div>
              ) : (
                <div className='col-lg-12 col-md-12'>
                  <div className='row justify-content-between align-items-center'>
                    <h2 className='title m-0'>
                      Bảng điều khiển | {profile?.name}
                    </h2>
                    <div className='d-flex'>
                      <a
                        className='btn__seeall flex-center m-0 mr-4 w-auto pr-2 pl-2'
                        href='/bang-dieu-khien/cap-nhat-thong-tin'
                      >
                        Cập nhật thông tin
                      </a>
                      <btn
                        className='btn__seeall flex-center m-0'
                        // onClick={openFormResetPassword}
                        data-toggle='modal'
                        data-target='#modal-form-reset-password'
                      >
                        Đổi mật khẩu
                      </btn>
                    </div>
                  </div>
                  <InfoCompanyStatus profile={profile} />
                  <div className='d-flex mb-4'>
                    <a
                      className='btn__seeall flex-center m-0 mr-4 w-auto pr-2 pl-2'
                      href='/bang-dieu-khien/bao-cao-chuyen-doi-so'
                    >
                      Báo cáo số liệu CĐS
                    </a>
                  </div>
                  <Appliants
                    applications={applications}
                    onOpenAction={openAction}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
      <ModalLogin />
      <ModalRegister />
      <ModalAction application={application} setApplication={setApplication} />
      <ModalResetPassword />
      <ModalResult
        title='Thành công'
        subtitle='Thay đổi mật khẩu thành công'
        onHandle={() => {
          window.location.href = '/';
        }}
      />
      <Footer />
    </div>
  );
};
export default Dashboard;
